import * as yup from "yup";
import translate from "../../Utils/translate";

const domainRegExp =
  /^(?=.{4,2048}$)((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]{1,63}(\.[a-zA-Z]{1,63}){1,5}(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gi;

export default yup.object().shape({
  domain: yup
    .string()
    .matches(domainRegExp, translate("validations.domain.not_valid"))
    .required(translate("validations.domain.required")),
  accountName: yup.string(),
  username: yup.string().required(translate("validations.username_email.required")),
  password: yup.string().required(translate("validations.password.required")),
  tags: yup.string().required(translate("validations.account_type.required")),
});
